// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"UVuay2b","slide":"KtC1jkF"};